/**
 * Purely decorative, animated gradient blobs. Pure CSS (no images, no
 * canvas) so it stays lightweight — see .ceremony-page__blob in
 * CeremonyPage.css for the drift animation, disabled under
 * prefers-reduced-motion via the global rule in src/index.css.
 */
export default function CeremonyBackground() {
  return (
    <div className="ceremony-page__background" aria-hidden="true">
      <span className="ceremony-page__blob ceremony-page__blob--one" />
      <span className="ceremony-page__blob ceremony-page__blob--two" />
      <span className="ceremony-page__blob ceremony-page__blob--three" />
    </div>
  );
}
